export const TYPES = {
  ALERT: 0,
  CONFIRM: 1,
  PROMPT: 2
}



// WEBPACK FOOTER //
// ./src/services/messagebox/constants.js